(function () {
'use strict';
var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var design = document.documentElement.classList.contains('shopify-design-mode');
var COLORS = ['#F4732A', '#48C4F3', '#FFE144', '#FF7F50', '#2e4057', '#ffffff'];
function onReady(fn) {
if (document.readyState !== 'loading') fn();
else document.addEventListener('DOMContentLoaded', fn);
}
function initScroll() {
var bar = document.createElement('div');
bar.className = 'sp-progress';
bar.setAttribute('aria-hidden', 'true');
document.body.appendChild(bar);
var ticking = false;
function update() {
var h = document.documentElement.scrollHeight - window.innerHeight;
var p = h > 0 ? window.scrollY / h : 0;
bar.style.transform = 'scaleX(' + p.toFixed(4) + ')';
document.body.classList.toggle('sp-scrolled', window.scrollY > 40);
ticking = false;
}
window.addEventListener('scroll', function () {
if (!ticking) { requestAnimationFrame(update); ticking = true; }
}, { passive: true });
update();
}
function splitWords(el) {
if (!el || el.dataset.spSplit) return;
el.dataset.spSplit = '1';
var label = el.textContent.trim();
el.setAttribute('aria-label', label);
var i = 0;
(function walk(node) {
Array.prototype.slice.call(node.childNodes).forEach(function (child) {
if (child.nodeType === 3) {
var frag = document.createDocumentFragment();
child.textContent.split(/(\s+)/).forEach(function (part) {
if (!part) return;
if (/^\s+$/.test(part)) { frag.appendChild(document.createTextNode(part)); return; }
var s = document.createElement('span');
s.className = 'sp-word';
s.setAttribute('aria-hidden', 'true');
s.style.setProperty('--i', i++);
s.textContent = part;
frag.appendChild(s);
});
child.parentNode.replaceChild(frag, child);
} else if (child.nodeType === 1) {
walk(child);
}
});
})(el);
el.classList.add('sp-split');
requestAnimationFrame(function () {
requestAnimationFrame(function () { el.classList.add('is-in'); });
});
}
function initHero() {
var banner = document.querySelector('.banner');
if (!banner) return;
requestAnimationFrame(function () { banner.classList.add('sp-in'); });
if (!reduce && !design) splitWords(banner.querySelector('.banner__heading'));
if (reduce) return;
var cards = [
{ t: '7', bg: '#F4732A', x: '86%', y: '12%', r: '-12deg', d: '.3s' },
{ t: '0', bg: '#48C4F3', x: '91%', y: '55%', r: '10deg', d: '.6s' },
{ t: '+', bg: '#2e4057', x: '80%', y: '74%', r: '-6deg', d: '.9s' }
];
var wrap = document.createElement('div');
wrap.className = 'sp-floaters';
wrap.setAttribute('aria-hidden', 'true');
cards.forEach(function (c) {
var el = document.createElement('span');
el.className = 'sp-floater';
el.textContent = c.t;
el.style.left = c.x;
el.style.top = c.y;
el.style.background = c.bg;
el.style.setProperty('--r', c.r);
el.style.setProperty('--d', c.d);
wrap.appendChild(el);
});
banner.appendChild(wrap);
if (window.matchMedia('(hover: hover)').matches) {
banner.addEventListener('pointermove', function (e) {
var r = banner.getBoundingClientRect();
var dx = (e.clientX - r.left) / r.width - .5;
var dy = (e.clientY - r.top) / r.height - .5;
wrap.style.transform = 'translate(' + (dx * -18).toFixed(1) + 'px,' + (dy * -14).toFixed(1) + 'px)';
});
banner.addEventListener('pointerleave', function () { wrap.style.transform = ''; });
wrap.style.transition = 'transform .6s cubic-bezier(.2,.8,.2,1)';
}
}
function initCards() {
if (reduce || !window.matchMedia('(hover: hover)').matches) return;
document.addEventListener('pointermove', function (e) {
var card = e.target.closest && e.target.closest('.card-wrapper');
if (!card) return;
var inner = card.querySelector('.card__inner');
var c = card.querySelector('.card');
if (!inner || !c) return;
var r = card.getBoundingClientRect();
var px = (e.clientX - r.left) / r.width;
var py = (e.clientY - r.top) / r.height;
inner.style.setProperty('--mx', (px * 100).toFixed(1) + '%');
inner.style.setProperty('--my', (py * 100).toFixed(1) + '%');
c.style.transform = 'rotateX(' + ((.5 - py) * 6).toFixed(2) + 'deg) rotateY(' + ((px - .5) * 8).toFixed(2) + 'deg) translateY(-6px)';
}, { passive: true });
document.addEventListener('pointerout', function (e) {
var card = e.target.closest && e.target.closest('.card-wrapper');
if (card && !card.contains(e.relatedTarget)) {
var c = card.querySelector('.card');
if (c) c.style.transform = '';
}
});
}
function initMagnetic() {
if (reduce || !window.matchMedia('(hover: hover)').matches) return;
document.querySelectorAll('.banner .button, .rich-text .button').forEach(function (b) {
b.addEventListener('pointermove', function (e) {
var r = b.getBoundingClientRect();
var dx = e.clientX - (r.left + r.width / 2);
var dy = e.clientY - (r.top + r.height / 2);
b.style.transform = 'translate(' + (dx * .18).toFixed(1) + 'px,' + (dy * .25 - 2).toFixed(1) + 'px)';
});
b.addEventListener('pointerleave', function () { b.style.transform = ''; });
});
}
function initReveal() {
if (reduce || design || !('IntersectionObserver' in window)) return;
var groups = document.querySelectorAll('.multicolumn-list, .product-grid, .footer__blocks-wrapper');
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (en) {
if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
});
}, { rootMargin: '0px 0px -10% 0px' });
groups.forEach(function (g) {
Array.prototype.slice.call(g.children).forEach(function (child, idx) {
if (child.classList.contains('scroll-trigger')) return;
child.classList.add('sp-reveal');
child.style.setProperty('--sp-delay', (idx * 110) + 'ms');
io.observe(child);
});
});
}
function initStickyATC() {
if (document.body.dataset.template !== 'product') return;
var infoBox = document.querySelector('.product__info-container');
var btn = infoBox && infoBox.querySelector('.product-form__submit');
if (!btn) return;
var titleEl = infoBox.querySelector('.product__title h1, .product__title h2');
var imgEl = document.querySelector('.product__media img');
var bar = document.createElement('div');
bar.className = 'sp-sticky-atc';
bar.setAttribute('role', 'region');
bar.setAttribute('aria-label', titleEl ? titleEl.textContent.trim() : '');
if (imgEl) {
var img = document.createElement('img');
img.className = 'sp-sticky-atc__img';
img.src = imgEl.currentSrc || imgEl.src;
img.alt = '';
bar.appendChild(img);
}
var info = document.createElement('div');
info.className = 'sp-sticky-atc__info';
var t = document.createElement('div');
t.className = 'sp-sticky-atc__title';
t.textContent = titleEl ? titleEl.textContent.trim() : '';
var p = document.createElement('div');
p.className = 'sp-sticky-atc__price';
info.appendChild(t);
info.appendChild(p);
bar.appendChild(info);
var cta = document.createElement('button');
cta.type = 'button';
cta.className = 'button';
bar.appendChild(cta);
document.body.appendChild(bar);
function sync() {
var pe = infoBox.querySelector('.price--on-sale .price-item--sale') || infoBox.querySelector('.price-item--regular');
p.textContent = pe ? pe.textContent.trim() : '';
var label = btn.querySelector('span');
cta.textContent = (label ? label.textContent : btn.textContent).trim();
cta.disabled = btn.disabled;
}
sync();
new MutationObserver(sync).observe(infoBox, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
cta.addEventListener('click', function () {
if (btn.disabled) return;
btn.click();
});
var footer = document.querySelector('.footer');
var btnVisible = true, footerVisible = false;
function toggle() { bar.classList.toggle('is-visible', !btnVisible && !footerVisible); }
if ('IntersectionObserver' in window) {
new IntersectionObserver(function (e) {
var en = e[0];
btnVisible = en.isIntersecting || en.boundingClientRect.top > window.innerHeight / 2;
toggle();
}, { rootMargin: '-110px 0px 0px 0px' }).observe(btn);
if (footer) new IntersectionObserver(function (e) { footerVisible = e[0].isIntersecting; toggle(); }).observe(footer);
}
}
function confetti(x, y) {
if (reduce) return;
var c = document.createElement('canvas');
c.className = 'sp-confetti';
var dpr = Math.min(window.devicePixelRatio || 1, 2);
c.width = innerWidth * dpr; c.height = innerHeight * dpr;
document.body.appendChild(c);
var ctx = c.getContext('2d');
ctx.scale(dpr, dpr);
var parts = [];
for (var i = 0; i < 90; i++) {
var a = Math.random() * Math.PI * 2;
var v = 4 + Math.random() * 9;
parts.push({
x: x, y: y,
vx: Math.cos(a) * v, vy: Math.sin(a) * v - 6,
w: 6 + Math.random() * 6, h: 8 + Math.random() * 8,
rot: Math.random() * 6, vr: (Math.random() - .5) * .4,
col: COLORS[i % COLORS.length]
});
}
var start = performance.now();
(function frame(now) {
var dt = now - start;
ctx.clearRect(0, 0, innerWidth, innerHeight);
parts.forEach(function (q) {
q.vy += .35; q.vx *= .985; q.x += q.vx; q.y += q.vy; q.rot += q.vr;
ctx.save();
ctx.globalAlpha = Math.max(0, 1 - dt / 1800);
ctx.translate(q.x, q.y); ctx.rotate(q.rot);
ctx.fillStyle = q.col;
ctx.fillRect(-q.w / 2, -q.h / 2, q.w, q.h);
ctx.restore();
});
if (dt < 1800) requestAnimationFrame(frame); else c.remove();
})(start);
}
function initConfetti() {
var last = null;
document.addEventListener('click', function (e) {
var b = e.target.closest && e.target.closest('.product-form__submit, .sp-sticky-atc .button, .quick-add__submit');
if (b) { var r = b.getBoundingClientRect(); last = { x: r.left + r.width / 2, y: r.top + r.height / 2 }; }
}, true);
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
subscribe(PUB_SUB_EVENTS.cartUpdate, function (ev) {
if (ev && ev.source === 'product-form' && !(ev.cartData && ev.cartData.status)) {
var pt = last || { x: innerWidth / 2, y: innerHeight / 2 };
confetti(pt.x, pt.y);
last = null;
}
});
}
}
var ICONS = {
lock: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="4" y="11" width="16" height="10" rx="2"/><path d="M8 11V7a4 4 0 0 1 8 0v4"/></svg>',
truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h11v10H3z"/><path d="M14 9h4l3 3v4h-7"/><circle cx="7" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
back: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 14L4 9l5-5"/><path d="M4 9h10a6 6 0 0 1 0 12h-3"/></svg>'
};
function initTrust() {
document.querySelectorAll('product-form .product-form__buttons').forEach(function (btns) {
if (btns.closest('quick-add-modal') || btns.parentNode.querySelector('.sp-trust')) return;
var ul = document.createElement('ul');
ul.className = 'sp-trust';
ul.innerHTML = '<li>' + ICONS.lock + 'Paiement sécurisé · TWINT et cartes</li>' +
'<li>' + ICONS.truck + 'Livraison offerte dès 2 jeux</li>' +
'<li>' + ICONS.back + 'Satisfait ou remboursé 14 jours</li>';
btns.parentNode.insertBefore(ul, btns.nextSibling);
});
}
var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
var CUR = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'CHF';
var PAIRS = { ziro: 'numixor', numixor: 'ziro' };
var shipToken = 0;
function money(c) { return (c / 100).toFixed(2) + ' ' + CUR; }
function imgUrl(u, w) {
if (!u) return '';
if (u.indexOf('//') === 0) u = 'https:' + u;
return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
}
function shipBox(n) {
var done = n >= 2;
var box = document.createElement('div');
box.className = 'sp-ship' + (done ? ' is-done' : '');
box.innerHTML = '<p class="sp-ship__msg">' + (done ? '🎉 Bravo, la livraison est offerte !' : 'Ajoutez un 2<sup>e</sup> jeu et la livraison est offerte 🎁') + '</p><div class="sp-ship__track"><span style="width:' + (done ? 100 : 50) + '%"></span></div>';
return box;
}
function addToDrawer(variantId, btn) {
btn.disabled = true;
var drawer = document.querySelector('cart-drawer');
fetch(ROOT + 'cart/add.js', {
method: 'POST',
headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname })
}).then(function (r) { return r.json(); }).then(function (res) {
if (res.status) { btn.disabled = false; return; }
if (drawer && res.sections && typeof drawer.renderContents === 'function') {
drawer.renderContents({ id: variantId, sections: res.sections });
} else { window.location.reload(); return; }
var r = btn.getBoundingClientRect();
confetti(r.left + r.width / 2, r.top + r.height / 2);
if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sp-xsell', cartData: res });
}).catch(function () { window.location.reload(); });
}
function xsell(cart, after) {
var item = cart.items[0];
var other = item && PAIRS[item.handle];
if (!other) return;
fetch(ROOT + 'products/' + other + '.js').then(function (r) { return r.ok ? r.json() : null; }).then(function (p) {
if (!p || !p.available || !after.isConnected) return;
var v = p.variants.filter(function (x) { return x.available; })[0];
if (!v) return;
var old = after.parentNode.querySelector('.sp-xsell');
if (old) old.remove();
var el = document.createElement('div');
el.className = 'sp-xsell';
var img = p.featured_image ? '<img src="' + imgUrl(p.featured_image, 160) + '" alt="" loading="lazy">' : '';
el.innerHTML = img + '<div class="sp-xsell__info"><div class="sp-xsell__k">Complétez la partie</div><div class="sp-xsell__t"></div><div class="sp-xsell__p">' + money(v.price) + '</div></div><button type="button" class="button">Ajouter</button>';
el.querySelector('.sp-xsell__t').textContent = p.title;
el.querySelector('.button').addEventListener('click', function () { addToDrawer(v.id, this); });
after.parentNode.insertBefore(el, after.nextSibling);
});
}
function refreshShip() {
var token = ++shipToken;
fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
if (token !== shipToken) return;
var spots = [];
var drawerInner = document.querySelector('cart-drawer .drawer__inner');
if (drawerInner) spots.push({ box: drawerInner, anchor: drawerInner.querySelector('.drawer__header'), drawer: true });
var page = document.querySelector('#main-cart-items');
if (page) spots.push({ box: page, anchor: page.querySelector('.title-wrapper-with-link'), drawer: false });
spots.forEach(function (s) {
s.box.querySelectorAll('.sp-ship, .sp-xsell').forEach(function (n) { n.remove(); });
if (!cart.item_count) return;
var b = shipBox(cart.item_count);
if (s.anchor) s.anchor.parentNode.insertBefore(b, s.anchor.nextSibling); else s.box.insertBefore(b, s.box.firstChild);
if (cart.item_count === 1 && s.drawer) xsell(cart, b);
});
}).catch(function () {});
}
function initShip() {
refreshShip();
var drawer = document.querySelector('cart-drawer');
if (drawer && 'MutationObserver' in window) {
var t;
new MutationObserver(function () {
var inner = drawer.querySelector('.drawer__inner');
if (!inner || inner.classList.contains('is-empty') || inner.querySelector('.sp-ship')) return;
clearTimeout(t);
t = setTimeout(refreshShip, 120);
}).observe(drawer, { childList: true, subtree: true });
}
if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(refreshShip, 150); });
}
}
onReady(function () {
initScroll();
initHero();
initCards();
initMagnetic();
initReveal();
initStickyATC();
initTrust();
});
window.addEventListener('load', function () { initConfetti(); initShip(); });
})();